import type { FC } from "react";
import { MoonLoader } from "react-spinners";
import { Navbar } from "../../components/layout/NavBar";
import { TablaGastos } from "../../components/tablas/TablaGastos/TablaGastos";
import { useRutasActions, useRutasState } from "../../context/AppContext";
import { formatearNumeros } from "../../utils/formatters";
import { calcularSaldoActualRuta } from "../../utils/rutaMovimientos";
import { useGastosDiarios } from "./gastosDiariosHooks";
import type { UsersPageProps } from "./types";

export const GastosDiarios: FC<UsersPageProps> = () => {
  const { usuarioRuta } = useRutasState();
  const { setUsuarioRuta } = useRutasActions();

  const {
    valor,
    descripcion,
    isAdding,
    canSubmit,
    handleValorChange,
    handleDescripcionChange,
    agregarGasto,
  } = useGastosDiarios({
    usuarioRuta,
    setUsuarioRuta,
  });

  if (!usuarioRuta) {
    return (
      <>
        <Navbar />
        <div className="w-full min-h-screen h-full bg-gray-200 pt-16 px-4 md:px-8 pb-4">
          <div className="w-full h-[60vh] flex flex-col justify-center items-center gap-3">
            <MoonLoader size={32} color="#8131bd" />
            <span className="font-semibold text-center">Cargando ruta...</span>
          </div>
        </div>
      </>
    );
  }

  const saldoActualRuta = calcularSaldoActualRuta(usuarioRuta);

  return (
    <>
      <Navbar />
      <div className="w-full min-h-screen h-full bg-gray-200 pt-16 px-4 md:px-8 pb-4">
        <div className="w-full flex-col gap-2 flex justify-center items-center">
          <h2 className="font-bold text-lg">Agregar Gasto</h2>
          <div className="bg-white border shadow-[2px_2px_8px_rgb(0,0,0,0.5)] border-gray-400 w-full md:w-[400px] p-4 rounded-md max-h-[90%]">
            <div className="flex flex-col items-center mb-2 ">
              <span className="text-xl font-bold leading-4 md:leading-3">
                {`R$${formatearNumeros(saldoActualRuta)}`}
              </span>
              <span className="text-xs md:text-base md:font-semibold font-bold">
                SALDO DISPONIBLE
              </span>
            </div>
            <form onSubmit={agregarGasto}>
              <div className="flex w-full h-[40px] border border-gray-400 rounded-md">
                <div className="h-full w-[50%] bg-gray-200 flex items-center justify-center rounded-l-md border-r border-gray-400">
                  Valor del gasto
                </div>
                <input
                  type="number"
                  value={valor}
                  className="flex-1 rounded-r-md w-[50%] px-2 focus:border-transparent focus:outline-none"
                  onChange={handleValorChange}
                  required
                />
              </div>
              <div className="flex w-full h-[40px] border border-gray-400 rounded-md mt-1">
                <div className="h-full w-[50%] bg-gray-200 flex items-center justify-center rounded-l-md border-r border-gray-400">
                  Descripcion
                </div>
                <input
                  type="text"
                  value={descripcion}
                  className="flex-1 rounded-r-md w-[50%] px-2 focus:border-transparent focus:outline-none"
                  onChange={handleDescripcionChange}
                  required
                />
              </div>
              <button
                type="submit"
                className="bg-[#8131bd] mt-2 mx-auto w-fit text-white px-2 py-1 rounded-md flex justify-center items-center min-w-[80px]"
                disabled={!canSubmit}
              >
                {isAdding ? <MoonLoader size={20} color="#ffffff" /> : "Agregar"}
              </button>
            </form>
          </div>
          <TablaGastos usuarioRuta={usuarioRuta} />
        </div>
      </div>
    </>
  );
};
